'use strict';

import axios from 'axios';

import Model from './model.js';

export default class Coupon extends Model {
    urlRoot() { return '/Coupons'; }

    constraints() {
        return {
            code: {presence: {message: '^Coupon code is required'}},
            uses: {
                presence: {message: '^Number of uses is required'},
                numericality: {message: '^Coupon uses must be a number'}
            }
        };
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    static getDiscountCodes() {
        return axios({
            method: 'get',
            url: new Coupon().baseUrl() + '/discountCodes',
            headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(res => res.data)
        .catch(err => {
            throw err.response.data.error;
        });
    }
}



// WEBPACK FOOTER //
// ./app/new-models/coupon.js